import { SURVEY_QUESTION_RESPONSE_OPTIONS } from '../enums/survey-question-response-options.enum';

export interface UserSurveyResponse {
    surveyId: string;
    userId: string;
    username: string;
    organizationId: string;
    organizationName: string;
    responses: {
        question1: SURVEY_QUESTION_RESPONSE_OPTIONS;
        question2?: string;
        question3?: string;
        question4?: string;
    };
    completedAt?: Date;
}
